import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import WarningDialogIcon from "@entrilia/shared/icons/WarningDialogIcon";

interface Props {
  actionName: string;
  onClose: () => void;
}

const NoApproversWarningDialog = ({ actionName, onClose }: Props) => {
  return (
    <SmallDialog open onClose={onClose}>
      <DialogTitle>Error</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <Stack spacing={3} sx={{ alignItems: "center" }}>
          <WarningDialogIcon sx={{ width: 80, height: 80 }} />

          <Stack spacing={1} sx={{ alignItems: "center" }}>
            <Typography variant="h6">{actionName} cannot be executed.</Typography>
            <Typography color="textSecondary" sx={{ textAlign: "center" }}>
              No approvers are available. Please double check the rules in the approval configuration.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogButtons>
        <Button variant="contained" color="primary" onClick={onClose}>
          Close
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default NoApproversWarningDialog;
